module.exports = __webpack_public_path__ + "img/resource.3551b6f1.png";